// extracted by mini-css-extract-plugin
export default {"controlAttemps":"ControlAttempts_controlAttemps__lCocP","rotate":"ControlAttempts_rotate__dCFgH"};